import { Component, ElementRef, Inject, ViewChild } from '@angular/core'
import { AttributionControl, Map } from 'maplibre-gl'
import { MapService } from '../../services/map.service'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from '../../models'
import { map } from 'lodash'

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  standalone: false,
})
export class MapComponent {
  map: Map | undefined

  @ViewChild('map')
  private mapContainer!: ElementRef<HTMLElement>

  constructor(
    private mapService: MapService,
    @Inject(APP_CONFIG) private readonly config: AppConfigModel,
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    const initialState = { lng: 10.15166632952878, lat: 50.61449368770255, zoom: 5 }

    this.map = new Map({
      container: this.mapContainer.nativeElement,
      style: `${this.config.map_style_urls.dark}?key=${this.config.maptiler_key}`,
      center: [initialState.lng, initialState.lat],
      zoom: initialState.zoom,
      transformRequest: (url, resourceType) => {
        if (resourceType === 'Tile') {
          // Force tile zoom level to 15
          url = url.replace(/\/(\d+)\/(\d+)\/(\d+)\.png/, '/15/$2/$3.png')
        }
        return { url }
      },

      maxZoom: 22,
      fadeDuration: 0,
      attributionControl: false,
    })
    this.map.addControl(
      new AttributionControl({
        compact: false,
      }),
      'bottom-left',
    )
    this.mapService.initMap(this.map)
  }

  ngOnDestroy() {
    this.map?.remove()
  }
}
